import { call, takeEvery, takeLatest, delay, all, put } from 'redux-saga/effects'
import { savedVinWiseOpening, fetchedVinWiseOpening, storeSearchVinWiseOpeningResult, deletedVinWiseOpening } from './actions'
import axios from 'axios';
import { handlError, parseError } from '../../app/serverError'
import { URL, getHeaderJWT } from '../../../store/path'
import userACL from '../../../store/access'
import { merge } from 'lodash'

// const delay = (ms) => new Promise(res => setTimeout(res, ms))

//#region Saga for Create VinWiseOpening

function* createVinWiseOpening() {
  yield takeEvery('CREATE_VIN_WISE_OPENING', saveVinWiseOpening)
}

function* saveVinWiseOpening(action) {
  const { response, error } = yield call(saveVinWiseOpeningAPI, action.payload)
  if (response) {
    if (response.data.type && response.data.type === "error") {
      yield put(savedVinWiseOpening(action.payload, "error", response.data.data || response.data.msg || 'Operation failed.'))
    } else {
      yield put(savedVinWiseOpening(action.payload, "success", response.data.msg || response.data.data || 'Saved successfully.'))
    }
  }
  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function saveVinWiseOpeningAPI(data) {
  try {
    const response = await axios.post(URL + '/master/vin_wise_opp/add', data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for Edited VinWiseOpening

function* editVinWiseOpening() {
  yield takeEvery('EDIT_VIN_WISE_OPENING', saveEditedVinWiseOpening)
}

function* saveEditedVinWiseOpening(action) {
  const { response, error } = yield call(editVinWiseOpeningAPI, action.payload)
  if (response) {
    if (response.data.type && response.data.type === "error") {
      yield put(savedVinWiseOpening(action.payload, "error", response.data.data || response.data.msg || 'Operation failed.'))
    } else {
      yield put(savedVinWiseOpening(action.payload, "success", response.data.msg || response.data.data || 'Saved successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function editVinWiseOpeningAPI(data) {
  try {
    const response = await axios.post(URL + '/master/vin_wise_opp/update/' + data.vin, data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for Delete VinWiseOpening

function* deleteVinWiseOpening() {
  yield takeEvery('DELETE_VIN_WISE_OPENING', saveDeleteVinWiseOpening)
}

function* saveDeleteVinWiseOpening(action) {
  const { response, error } = yield call(deleteVinWiseOpeningAPI, action.payload)
  if (response) yield put(deletedVinWiseOpening({ id: action.payload.id, msg: response.data }))
  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function deleteVinWiseOpeningAPI(data) {
  let vinWiseOpeningId = data.id
  try {
    const response = await axios.post(URL + '/vin_wise_opp/delete/' + vinWiseOpeningId, data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for List VinWiseOpening

function* fetchVinWiseOpening() {
  yield takeEvery('FETCH_VIN_WISE_OPENING', requestVinWiseOpening)
}


function* requestVinWiseOpening() {
  let { data } = yield call(requestVinWiseOpeningAPI)
  yield put(fetchedVinWiseOpening(data.data))
}


function requestVinWiseOpeningAPI(data) {
  data = merge({}, data, userACL.atFetch())
  return axios.post(URL + '/master/vin_wise_opp/list', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


//#region Saga for Search VinWiseOpening

function* searchVinWiseOpening() {

  yield takeLatest('SEARCH_VIN_WISE_OPENING', initiateSearch)

}

function* initiateSearch(action) {
  yield delay(350)
  let { data } = yield call(searchAPI, action.payload)
  yield put(storeSearchVinWiseOpeningResult(data))

}

function searchAPI(data) {
  return axios.post(URL + '/vin_wise_opp/search/' + data, data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* vinWiseOpeningSaga() {
  yield all([
    createVinWiseOpening(),
    fetchVinWiseOpening(),
    editVinWiseOpening(),
    deleteVinWiseOpening(),
    searchVinWiseOpening()
  ])
}